module.exports = __webpack_public_path__ + "img/lg_ring_r_e_1_1@2x.ca6c5306.png";